import { gql } from '@apollo/client';
import { ProductInfoShared } from '@retainerclub/shared-api';

export default gql`
  query paidInOfficeProducts($partnerLocationId: ID, $patientId: ID) {
    paidInOfficeProducts(partnerLocationId: $partnerLocationId, patientId: $patientId) {
      accountCanOrderFreeTrial
      freeTrialRequiresCreditCard
      patientHasPendingFreeTrialReferral
      eotRetainers {
        ...ProductInfoShared
      }
      regularRetainers {
        ...ProductInfoShared
      }
      plans {
        ...ProductInfoShared
      }
      otherProducts {
        ...ProductInfoShared
      }
      otherPriceBookProducts {
        ...ProductInfoShared
      }
      allOtherProducts {
        ...ProductInfoShared
      }
    }
  }
  ${ProductInfoShared}
`;
